import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const usePowerAppsPathListener = (iframeRef: React.RefObject<HTMLIFrameElement>) => {
  const location = useLocation();
  const lastPathRef = useRef(location.pathname);
  const firstRenderRef = useRef(true);

  useEffect(() => {
    // Skip iframe manipulation on first render
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }

    if (!iframeRef.current) {
      console.warn('[PowerApps][PathListener] iframe reference not available');
      return;
    }

    if (lastPathRef.current === location.pathname) {
      // Force reload the iframe if the path hasn't changed
      console.info('[PowerApps][PathListener] Reloading iframe for same path navigation');
      iframeRef.current.src = iframeRef.current.src;
    } else {
      console.info(
        `[PowerApps][PathListener] Path changed from ${lastPathRef.current} to ${location.pathname}`,
      );
    }

    lastPathRef.current = location.pathname;
  }, [iframeRef, location]);
};
